<template>
  <div class="summary-chart">
    <VueApexCharts type="bar" width="100%" height="300" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'SummaryChart',
  components: { VueApexCharts },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    series() {
      return [
        {
          name: 'Moves',
          data: this.data.map(itm => itm.count_jobs),
        },
        {
          name: 'Leads',
          data: this.data.map(itm => itm.count_leads),
        },
        {
          name: 'Claims',
          data: this.data.map(itm => itm.count_claims),
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: 250,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
            borderRadius: 5,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        xaxis: {
          categories: this.data.length > 1 ? this.data.map(itm => itm.label) : [''],
          labels: {
            style: {
              colors: this.data.map(() => '#a9a9a9'),
            },
          },
        },
        yaxis: {
          title: {
            text: '',
          },
          labels: {
            formatter(val) {
              return Math.floor(val);
            },
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            // eslint-disable-next-line func-names
            formatter(val) {
              return val;
            },
          },
        },
        colors: ['#2978fe', '#fdaa01', '#fd2979'],
        legend: {
          position: 'top',
          markers: {
            radius: 10,
          },
          labels: {
            colors: '#a9a9a9',
          },
        },
      };
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/salesDashboard/subcomponents/cards/Summary/SummaryChart.vue